import React, {Component} from "react"
import "./Footer.css"
class Footer extends Component{
    render(){
        return <footer>
            &copy; Arth<br/>
            Site owned and maintained by Arth
        </footer>
    }
}

export default Footer